import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import _ from 'lodash';
import Text from '../text';
import Colors from '../colors';
import Spacer from '../spacer';
const Container = styled.View`
  flex-direction: column;
  justify-content: center;
`;
const NameContainer = styled.View`
  flex-direction: row;
  justify-content: center;
`;
export default function UserDetails(props) {
  const color = props.theme === 'light' ? Colors.white : Colors.gray500;
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(NameContainer, null, /*#__PURE__*/React.createElement(Text.BodySmall, {
    align: "center",
    weight: "bold",
    color: color
  }, props.name), _.isFunction(props.icon) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    size: "f6",
    width: true
  }), props.icon())), /*#__PURE__*/React.createElement(Text.BodyExtraSmall, {
    align: "center",
    color: color
  }, props.company));
}
UserDetails.propTypes = {
  name: PropTypes.string,
  company: PropTypes.string,
  icon: PropTypes.func,
  theme: PropTypes.oneOf(['default', 'light'])
};
UserDetails.defaultProps = {
  name: '',
  company: '',
  icon: null,
  theme: 'default'
};
//# sourceMappingURL=user-details.js.map